import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { floatToStringFormat, stringFormatToFloat } from 'src/app/fieldTypes/TextFields';
import { TITLE } from 'src/app/utils/enum';
import { DOCSO } from '../../../../fieldTypes/NumToWord';
import { FormFieldInfo } from '../../../../models/forms-response.models';

@Component({
    selector: 'app-component-number-currency',
    templateUrl: './number-currency.component.html',
    styleUrls: ['./number-currency.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NumberCurrencyComponent implements OnInit, AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    @Input() formGroup: FormGroup;
    @Input() formData: any;
    @Input() modalTitle:any;

    taxCode="";
    formCode="";
    formFieldConfig: any;
    fieldConfig: any;
    isRequired: boolean;
    name: string;
    hideTitle: boolean;
    isMathRound: boolean;
    text: string;
    textEN: string;
    unit = "đồng";
    subject: Subject<any> = new Subject();
    value = "0";
    input = "";
    defaultValue: string;
    tooltip: string;
    fieldCode: string;
    fieldDataInfo:any;

    constructor(private nzModalNotification: NzNotificationService, private cdref: ChangeDetectorRef) { }

    ngOnInit(): void {
        try {
            this.formFieldConfig = this.formFieldInfo.formFieldConfig ? JSON.parse(this.formFieldInfo.formFieldConfig) : "";
            this.fieldConfig = this.formFieldInfo.fieldConfig ? JSON.parse(this.formFieldInfo.fieldConfig) : "";
            this.fieldCode = this.formFieldInfo.fieldCode;
            this.fieldDataInfo=this.formFieldInfo;
            this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
            this.name = (this.formFieldConfig && this.formFieldConfig.displayText) ? this.formFieldConfig.displayText : this.formFieldInfo.name;

            this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
            this.isMathRound = (this.formFieldConfig && this.formFieldConfig.isMathRound) ? this.formFieldConfig.isMathRound : false;
            this.defaultValue = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? this.formFieldInfo.defaultValue : '';
            this.tooltip = this.formFieldConfig && this.formFieldConfig.tooltip ? this.formFieldConfig.tooltip : "";
            this.formCode=localStorage.getItem('FORM_CODE');
            this.taxCode=localStorage.getItem('TAXCODE');
            this.bindingData();
        } catch (error) {
            this.formFieldConfig = JSON.parse('{ "pattern": "" }');
            this.fieldConfig = JSON.parse('{ "keydownPattern": "" }');
        }
    }

    bindingData(){
        if (this.modalTitle == TITLE.ADD_DATA)//This case is: Click icon(+) to open popup
        {
            this.value = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? this.formFieldInfo.defaultValue : this.formFieldConfig.defaultValue ? this.formFieldConfig.defaultValue : "";
        }
        else if (this.modalTitle == TITLE.UPDATE_DATA) { //This case is: Click icon(edit) to open popup
            if (this.formData) {
                let objectData = this.formData;
                const keys = Object.keys(objectData);
                keys.forEach((key) => {
                    if (key == this.formFieldInfo.fieldCode) {
                        let value = objectData[key];
                        this.value = value;
                    }
                });
            }
        }
        else {
            this.value = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? this.formFieldInfo.defaultValue : this.formFieldConfig.defaultValue ? this.formFieldConfig.defaultValue : "";
            let storageVal = localStorage.getItem("VALUE_" +this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ this.fieldCode);
            if (storageVal) {
                this.value = storageVal;
            }
            this.text = DOCSO.doc(this.value, this.unit);
            this.textEN = DOCSO.docEn(stringFormatToFloat(this.value), this.unit);
            this.subject.pipe( debounceTime(500)).subscribe( () => {
                this.numToWords();}
            )
        }
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    onchangeNumberCurrencyField(e) {
        this.input = e.target.value;
        this.subject.next();
    }

    numToWords() {
        if (this.input) {
            let input = this.input;
            var valNumber: any = input.toString().replace(/[\*\^\,\'\!]/g, '');
            var validate = true;
            let message = "";

            if (isNaN(valNumber)) {
                validate = false;
                message = "Sai định dạng format";
            } else {
                if (valNumber) {
                    if (valNumber.split('.')[1] != undefined && valNumber.split('.')[1] != "") {
                        var valueNumeric = floatToStringFormat(valNumber);
                        this.value = valueNumeric;
                        this.text = DOCSO.doc(input.replace(/[*^'!,]/g, ''), this.unit);
                        this.textEN = DOCSO.docEn(stringFormatToFloat(input), this.unit);

                    } else {
                        var valueNumeric = floatToStringFormat(parseFloat(valNumber));
                        if (!valNumber.includes('.')) {
                            this.value = valueNumeric;
                            this.text = DOCSO.doc(input.replace(/[*^'!,]/g, ''), this.unit);
                            this.textEN = DOCSO.docEn(stringFormatToFloat(input), this.unit);
                        }
                    }
                }
            }

            if (!validate) {
                this.nzModalNotification.error("Cảnh báo", "Chuỗi text " + message);
            }
        }
    }

    modelChange() {
        localStorage.setItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode+ '_'+ this.fieldCode, this.value);
    }
}